import {
    Component,
    ComponentFactoryResolver,
    OnInit,
    ViewContainerRef,
  } from "@angular/core";
  import {
    cacheReadyOperator,
    FlowNodeController,
  } from "../../flow-node.controller";
  import { FlowsService } from "../../flows.service";
  import { ActivatedRoute, Router } from "@angular/router";
  import { forkJoin } from "rxjs";
  import { UiService } from "src/app/ui/ui.service";
  import { MatDialog } from "@angular/material/dialog";
  import { EMailNodeMenuComponent } from "./email-node-menu/email-node-menu.component";
  import { takeUntil } from "rxjs/operators";
  
  @Component({
    selector: "app-email-node",
    templateUrl: "./email-node.component.html",
    styleUrls: ["./email-node.component.scss"],
  })
  export class EMailNodeComponent
    extends FlowNodeController
    implements OnInit
  {
    icon!: string;

    constructor(
      factoryResolver: ComponentFactoryResolver,
      ViewContainerRef: ViewContainerRef,
      FlowsService: FlowsService,
      Router: Router,
      uiService: UiService,
      MatDialog: MatDialog,
      private route: ActivatedRoute,
    ) {
      super(
        factoryResolver,
        ViewContainerRef,
        FlowsService,
        Router,
        uiService,
        MatDialog,
      );
    }
  
    async ngOnInit(): Promise<void> {

      super.ngOnInit();

      this.icon = this.node.is_follow_up
      ? "assets/svg/flows/email-follow-up.svg"
      : "assets/svg/flows/email.svg";

      forkJoin([
        this.FlowsService.emailCacheReady.pipe(cacheReadyOperator())
      ])
        .pipe(takeUntil(this.onComponentDestroy))
        .subscribe(() => {
          const factory = this.factoryResolver.resolveComponentFactory(
            EMailNodeMenuComponent,
          );
          this.menuComponent = factory.create(
            this.flowMenuViewContainerRef.parentInjector,
          );
          this.menuComponent.instance.node = this.node;
          this.menuComponent.instance.selected = this.selected;
          this.menuComponent.instance.onMenuSizeChange = this.onMenuSizeChange;
          this.menuComponent.instance.internal = this.internal;
  
          this.flowMenuViewContainerRef.insert(this.menuComponent.hostView);
          this.menuComponent.instance.onNodeMenuInstantiated
            .pipe(takeUntil(this.onComponentDestroy))
            .subscribe(() => {
              this.onMenuInstantiated.next();
              this.onMenuInstantiated.complete();
              this.onNodeReady.emit(this.componentRef);
            });
        });
  
      this.FlowsService.initEmailCache();

    }
  
    ngAfterViewInit() {
      super.ngAfterViewInit();
    }
  
    ngOnDestroy() {
      super.ngOnDestroy();
    }

  }
  